export default __webpack_public_path__ + "static/media/logomenu.f61203f6.png";